import { createAction } from "../helpers";
import { TimerDirection, UseTimerActionType } from "./useTimer.types";

export const Tick = (delta: number) =>
    createAction(UseTimerActionType.Tick, { delta });

export const ChangeDirection = (direction: TimerDirection) =>
    createAction(UseTimerActionType.ChangeDirection, { direction });

export const Stop = () => createAction(UseTimerActionType.Stop);

export const Start = (initialTime: number) =>
    createAction(UseTimerActionType.Start, { initialTime });

export type UseTimeAction =
    | ReturnType<typeof Tick>
    | ReturnType<typeof ChangeDirection>
    | ReturnType<typeof Start>
    | ReturnType<typeof Stop>;
